export default "__VITE_ASSET__Cq07UlVc__"